import { render, staticRenderFns } from "./edit-discount-voucher-modal.vue?vue&type=template&id=36f86879"
import script from "./edit-discount-voucher-modal.vue?vue&type=script&lang=js"
export * from "./edit-discount-voucher-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports